/* tslint:disable */
/* eslint-disable */
/**
 * Jack Burton Internal API
 * API for the Jack Burton platform
 *
 * The version of the OpenAPI document: v1 App
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime.js';
/**
 * 
 * @export
 * @interface UpdateScorecardTemplateRequest
 */
export interface UpdateScorecardTemplateRequest {
    /**
     * 
     * @type {string}
     * @memberof UpdateScorecardTemplateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof UpdateScorecardTemplateRequest
     */
    parameters?: string;
    /**
     * 
     * @type {boolean}
     * @memberof UpdateScorecardTemplateRequest
     */
    isDraft?: boolean;
}

/**
 * Check if a given object implements the UpdateScorecardTemplateRequest interface.
 */
export function instanceOfUpdateScorecardTemplateRequest(value: object): boolean {
    return true;
}

export function UpdateScorecardTemplateRequestFromJSON(json: any): UpdateScorecardTemplateRequest {
    return UpdateScorecardTemplateRequestFromJSONTyped(json, false);
}

export function UpdateScorecardTemplateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): UpdateScorecardTemplateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'parameters': json['parameters'] == null ? undefined : json['parameters'],
        'isDraft': json['isDraft'] == null ? undefined : json['isDraft'],
    };
}

export function UpdateScorecardTemplateRequestToJSON(value?: UpdateScorecardTemplateRequest | null): any {
    if (value == null) {
        return value;
    }
    return {
        
        'name': value['name'],
        'parameters': value['parameters'],
        'isDraft': value['isDraft'],
    };
}

